<template>
    <div>

        <b-modal id="create-or-update-passport" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <employee-passport-create-or-update v-model="passport" :errors="errors"></employee-passport-create-or-update>
            <template #modal-footer><v-executer  :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>
            
        <v-table    ref="table"
                    with-items
                    up-class="px-1 pb-1"
                    search
                    :items="value"
                    :add-callback="createNew"
                    :buttons="buttons"
                    name="employee-passport"
                    overlay-class="pb-0"
                    :fields="fields"></v-table>

    </div>
</template>

<script>
import EmployeePassportCreateOrUpdate from './EmployeePassportCreateOrUpdate.vue'
import randomatic from 'randomatic'
import moment from 'moment'

export default {
    components:{
        EmployeePassportCreateOrUpdate,
    },
    props:{
        value:Array,
        id:[String,Number]
    },
    data(){
        return{
            fields:[
                {name:"Pasaport Numarası",key:"PassportNumber",thClass:"w-15"},
                {name:"Pasaport Tipi",key:"PassportTypeName",tdClass:'text-nowrap',thClass:"w-55"},
                {name:"Bitiş Tarihi",key:"EndDateVisual",thClass:"w-15"},
                {name:"Aktif",key:"IsActive",thClass:"w-15"},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            passport:{
                Id:null,
                EmployeeId:null,
                PassportNumber:null,
                EndDate:null,
                EndDateVisual:null,
                IsActive:true,
                Type:null,
                PassportTypeName:null
            },
            errors:{},
            editing:false,
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.passport.Id = null
            this.passport.PassportNumber = null
            this.passport.EmployeeId = null
            this.passport.IsActive = true
            this.passport.Type = null
            this.passport.EndDate = null
            this.passport.EndDateVisual = null
            this.passport.PassportTypeName = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update-passport')
        },
        edit(item){
            this.clearForm() 
            this.editing = true
            this.passport.Id = item.Id
            this.passport.PassportNumber = item.PassportNumber
            this.passport.EmployeeId = item.EmployeeId
            this.passport.Type = item.Type
            this.passport.IsActive = item.IsActive
            this.passport.EndDate = item.EndDate
            this.passport.EndDateVisual = item.EndDateVisual
            this.$showModal('create-or-update-passport')
        },
        validation(){
            let count = 0
            if(this.$isNullOrEmpty(this.passport.PassportNumber)){
                this.$set(this.errors,'PassportNumber','Pasaport numrası alanı zorunludur.')
                count ++
            }
            if(this.$isNullOrEmpty(this.passport.Type)){
                this.$set(this.errors,'Type','Pasaport tipi alanı zorunludur.')
                count ++
            }
            if(this.$isNullOrEmpty(this.passport.EndDate)){
                this.$set(this.errors,'EndDate','Bitiş tarihi alanı zorunludur.')
                count ++
            }
            return count > 0 ? false : true
        },
        createOrUpdate(){
            if(this.validation()){
                if(this.passport.Id){
                    let item = this.value.find(r=> r.Id == this.passport.Id)
                    this.$set(item,"PassportNumber",this.passport.PassportNumber)
                    this.$set(item,"EmployeeId",this.passport.EmployeeId)
                    this.$set(item,"IsActive",this.passport.IsActive)
                    this.$set(item,"Type",this.passport.Type)
                    this.$set(item,"PassportTypeName",this.passport.PassportTypeName)
                    this.$set(item,"EndDate",this.passport.EndDate)
                    this.$set(item,"EndDateVisual",moment(this.passport.EndDate).locale("tr").format('L'))
                    this.$set(item,"Unsaved",true)
                }else{
                    this.value.push({
                        Id:randomatic("A0",10),
                        EmployeeId:this.id,
                        PassportNumber:this.passport.PassportNumber,
                        Type:this.passport.Type,
                        PassportTypeName:this.passport.PassportTypeName,
                        IsActive:this.passport.IsActive,
                        EndDate:this.passport.EndDate,
                        EndDateVisual:moment(this.passport.EndDate).locale("tr").format('L'),
                        Unsaved:true
                    })
                }
                this.$hideModal('create-or-update-passport')
            }
        },
        delete(item,key,index){
            this.$confirm("Silmek istediğinize emin misiniz?",`Bu işlem ${item.PassportNumber} numaralı pasaport bilgisini silecektir ve geri alınamaz.`).then(res=>{
                if(res){
                    this.$delete(this.value,index)
                }
            })
        },
    }
}
</script>

<style>

</style>